import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgBookmarkIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M46.002 4h-28a6.14 6.14 0 0 0-6 6.22v45.66a4 4 0 0 0 2.56 3.84 4 4 0 0 0 1.44.28 4 4 0 0 0 2.86-1.24l13.1-14 13.18 14a4 4 0 0 0 4.3.96 4 4 0 0 0 2.56-3.84V10.22a6.14 6.14 0 0 0-6-6.22m2 52-13.18-14a3.88 3.88 0 0 0-5.72 0l-13.1 13.88V10.22a2.12 2.12 0 0 1 2-2.22h28a2.12 2.12 0 0 1 2 2.22z"
    />
  </svg>
)
export default SvgBookmarkIcon
